import { render, staticRenderFns } from "./ccTargetingCategories.vue?vue&type=template&id=61885ac2"
import script from "./ccTargetingCategories.vue?vue&type=script&lang=js"
export * from "./ccTargetingCategories.vue?vue&type=script&lang=js"
import style0 from "./ccTargetingCategories.vue?vue&type=style&index=0&id=61885ac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports